import { render, staticRenderFns } from "./getOil.vue?vue&type=template&id=bc2129a6&scoped=true"
import script from "./getOil.vue?vue&type=script&lang=js"
export * from "./getOil.vue?vue&type=script&lang=js"
import style0 from "./getOil.vue?vue&type=style&index=0&id=bc2129a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2129a6",
  null
  
)

export default component.exports